import apiRequest from "./apiClient";

export async function fetchDefectsByDevice(deviceModelId, { includeInactive = true } = {}) {
  const query = includeInactive ? "?includeInactive=true" : "";
  const body = await apiRequest(`/api/v1/defects/device/${deviceModelId}${query}`);
  return body.data;
}

export async function createDefect(deviceModelId, payload) {
  const body = await apiRequest(`/api/v1/defects/${deviceModelId}`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateDefect(defectId, payload) {
  const body = await apiRequest(`/api/v1/defects/${defectId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

/** Legacy or catalog-global toggle (product type template) */
export async function toggleDefectStatus(defectId) {
  await apiRequest(`/api/v1/defects/${defectId}/defect`, { method: "PUT" });
}

/** Paginated central catalog for a product type */
export async function fetchCatalogDefects(categoryId, { page = 0, size = 20, includeInactive = true } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
    includeInactive: String(includeInactive),
  });
  const body = await apiRequest(`/api/v1/defects/catalog/category/${categoryId}?${params.toString()}`);
  return body.data;
}

/** Per-device model toggle — hides defect on mobile app for this model only */
export async function toggleDeviceCatalogDefect(deviceModelId, catalogDefectId) {
  await apiRequest(
    `/api/v1/defects/device/${deviceModelId}/catalog/${catalogDefectId}/toggle`,
    { method: "PUT" }
  );
}

/** Set model-specific price impact override (null resets to type default) */
export async function updateDeviceDefectImpact(deviceModelId, catalogDefectId, priceImpact) {
  const body = await apiRequest(
    `/api/v1/defects/device/${deviceModelId}/catalog/${catalogDefectId}/impact`,
    {
      method: "PUT",
      body: JSON.stringify({ priceImpact }),
    }
  );
  return body.data;
}

export async function fetchDefectGroups(productTypeId, { category, includeInactive = true } = {}) {
  const params = new URLSearchParams({
    productTypeId: String(productTypeId),
    includeInactive: String(includeInactive),
  });
  if (category) params.set("category", category);
  const body = await apiRequest(`/api/v1/defect-groups?${params.toString()}`);
  return body.data || [];
}

export async function createDefectGroup(payload) {
  const body = await apiRequest("/api/v1/defect-groups", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateDefectGroup(id, payload) {
  const body = await apiRequest(`/api/v1/defect-groups/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function deleteDefectGroup(id) {
  await apiRequest(`/api/v1/defect-groups/${id}`, { method: "DELETE" });
}

/** Hard-delete central catalog defect when unused by orders */
export async function deleteCatalogDefect(catalogDefectId) {
  await apiRequest(`/api/v1/defects/catalog/${catalogDefectId}`, { method: "DELETE" });
}

/** Delete unused central defects with no group / invalid group for a product type */
export async function deleteUngroupedCatalogDefects(categoryId) {
  const body = await apiRequest(`/api/v1/defects/catalog/category/${categoryId}/ungrouped`, {
    method: "DELETE",
  });
  return body.data ?? 0;
}
